import { ServiceType } from "./hooks/api/use-services";
import { LeadUpdateAction } from "./hooks/api/use-campaigns";

export const FILTER_SEPARATOR = "__";

export const LEVELS = [
  { label: "verbose", value: "verbose" },
  { label: "debug", value: "debug" },
  { label: "log", value: "log" },
  { label: "warn", value: "warn" },
  { label: "error", value: "error" },
  { label: "fatal", value: "fatal" },
];

export const DUPLICATE_STRATEGY = [
  { label: "Skip", value: "skip" },
  { label: "Update", value: "update" },
]

export const LEAD_STATUS = [
  { label: "Queued", value: "queued" },
  { label: "New", value: "pending" },
  { label: "Scheduled", value: "scheduled" },
  { label: "Processing", value: "processing" },
  { label: "Completed", value: "done" },
  // Terminal, set when the contact lands on the account's do-not-call list. Added to the
  // backend enum by the suppression work; without it here the chip rendered with no label
  // at all, and the status filter could not select these leads.
  { label: "Do not call", value: "suppressed" },
]

export const LEAD_STATUS_COLORS = {
  queued: "info",
  pending: "primary",
  scheduled: "warning",
  processing: "primary",
  done: "success",
  suppressed: "error",
}

export const LEAD_ACTIONS = [
  { label: "Add to queue", value: LeadUpdateAction.ADD_TO_QUEUE },
  { label: "Schedule custom Call Back", value: LeadUpdateAction.SCHEDULE_CUSTOM_CALL_BACK },
  { label: "Reset Call Back Attempts", value: LeadUpdateAction.RESET_CALL_BACK_ATTEMPTS },
  { label: "Add to do-not-call list", value: LeadUpdateAction.DO_NOT_CALL_AGAIN },
  { label: "Re-fetch Dispositions & Summary", value: LeadUpdateAction.ANALYSE },
]

export const CAMPAIGN_STATUS_COLORS = {
  active: 'success',
  inactive: 'error',
  completed: 'info',
  scheduled: 'warning',
}

export const PERMISSIONS = {
  agent: 'agent',
  campaign: 'campaign',
  account: 'account',
  user: 'user',
  contact: 'contact',
  plugin: 'plugin',
  call: 'call',
  phoneNumber: 'phoneNumber',
  systemLog: 'systemLog',
  contactField: 'contactField',
  campaignField: 'campaignField',
  management: 'management',
  service: 'service',
  group: 'group',
  intakeKey: 'intakeKey',
  // Published runs, held apart from `agent` so a manager can be shown the evidence an agent
  // is fit to ship without being shown how it is configured.
  provingRun: 'provingRun',
};

export enum CallStatus {
  New = 0,
  Calling = 1,
  Conversation = 2,
  Ringing = 3,
  Busy = 50,
  NoAnswer = 51,
  Machine = 52,
  Finished = 100,
  Stuck = 101,
  Rejected = 254,
  Error = 250,
  Error255 = 255,
}

export const STACK_STATUSES = [
  CallStatus.New, 
  CallStatus.Calling, 
  CallStatus.Conversation,
  CallStatus.Ringing
];

export const CALL_STATUS_LABELS = {
  [CallStatus.New]: "New",
  [CallStatus.Calling]: "Calling",
  [CallStatus.Conversation]: "Conversation",
  [CallStatus.Ringing]: "Ringing",
  [CallStatus.Busy]: "Busy",
  [CallStatus.NoAnswer]: "No Answer",
  [CallStatus.Machine]: "Machine",
  [CallStatus.Finished]: "Finished",
  [CallStatus.Stuck]: "Stuck",
  [CallStatus.Rejected]: "Rejected",
  [CallStatus.Error]: "Error",
  [CallStatus.Error255]: "Error",
}

export const CALL_STATUS_COLORS = {
  [CallStatus.New]: "info",
  [CallStatus.Calling]: "primary",
  [CallStatus.Conversation]: "success",
  [CallStatus.Ringing]: "warning",
  [CallStatus.Busy]: "error",
  [CallStatus.NoAnswer]: "error",
  [CallStatus.Machine]: "error",
  [CallStatus.Finished]: "success",
  [CallStatus.Stuck]: "error",
  [CallStatus.Rejected]: "error",
  [CallStatus.Error]: "error",
  [CallStatus.Error255]: "error",
}
export const SERVICE_TYPE_OPTIONS = [
  { value: ServiceType.REALTIME, label: "Realtime" },
  { value: ServiceType.TTS, label: "TTS" },
  { value: ServiceType.LLM, label: "LLM" },
  { value: ServiceType.STT, label: "STT" },
  { value: ServiceType.VOICE, label: "Voice" },
  { value: ServiceType.EMAIL, label: "Email" },
  { value: ServiceType.CALENDAR, label: "Calendar" },
  { value: ServiceType.WEBHOOK, label: "Webhook" },
  { value: ServiceType.WEBSOCKET, label: "Websocket" },
  { value: ServiceType.EMBEDDING, label: "Embedding" },
  { value: ServiceType.AISDK, label: "AI SDK" },
]